export default __webpack_public_path__ + "static/media/05.c877c118.jpg";